import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Controller } from "react-hook-form";
import { ErrorWithIcon } from "./ValidationMessage";
import { ArrowDown2 } from "iconsax-react";
import { styled } from "@mui/material";
const StyledSelect = styled(Select)(({ theme, disabled }) => ({
    "& .MuiSelect-select": {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: "#FFFFFF",
        "&.Mui-focused": {
            border: `1px solid ${theme.palette.primary.main}`,
            backgroundColor: "#FFFFFF",
        },
        "&:before, &::after": {
            border: "none !important",
        },
    },
    "& .MuiSelect-icon": {
        color: disabled ? theme.palette.text.disabled : "#00244D99",
    },
    "& .MuiInputBase-input": {
        color: "#00244D",
    },
    "&.Mui-focused .MuiSelect-select": {
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: "#FFFFFF",
    },
    "&.Mui-error .MuiSelect-select": {
        border: `1px solid ${theme.palette.error.main}`,
    },
    "&.MuiFilledInput-root": {
        backgroundColor: "#FFFFFF",
        borderRadius: theme.shape.borderRadius,
        "&:hover": {
            backgroundColor: "#FFFFFF",
        },
        "&.Mui-focused": {
            backgroundColor: "#FFFFFF",
        },
        "&.MuiFilledInput-underline:before": {
            borderBottom: "none",
        },
        "&.MuiFilledInput-underline:after": {
            borderBottom: "none",
        },
        "&.MuiFilledInput-underline:hover:before": {
            borderBottom: "none",
        },
    },
    "& .MuiSelect-nativeInput": {
        borderRadius: theme.shape.borderRadius,
    },
    "& .MuiSelect-select.MuiSelect-select": {
        borderRadius: theme.shape.borderRadius,
    },
}));
const StyledFormControl = styled(FormControl)(({ theme }) => ({
    "& .MuiInputLabel-root": {
        "&.Mui-focused": {
            color: theme.palette.primary.main,
            transform: "translate(12px, -16px) scale(0.75)",
        },
        "&.MuiFormLabel-filled": {
            transform: "translate(12px, -16px) scale(0.75)",
        },
    },
}));
export const HSelect = ({ label, options, value, maxCharacter = 30, backgroundColor = "#FFFFFF", error, disabled, placeholder, height, rules, name, control, defaultValue, width, hiddenLabel = false, }) => {
    // const { i18n } = useTranslation();
    // const {  trigger } = useForm();
    // React.useEffect(() => {
    //   const onLangChange = () => {
    //     trigger(); // This re-runs validation and error messages
    //   };
    //   i18n.on("languageChanged", onLangChange);
    //   return () => {
    //     i18n.off("languageChanged", onLangChange);
    //   };
    // }, [i18n, trigger]);
    return (_jsxs(StyledFormControl, { variant: "filled", fullWidth: true, sx: { position: "relative", maxWidth: width }, hiddenLabel: hiddenLabel, children: [_jsx(InputLabel, { sx: {
                    fontWeight: 400,
                    "&.Mui-focused": {
                        fontWeight: 400,
                    },
                }, id: "demo-simple-select-filled-label", error: !!error, children: label }), _jsx(Controller, { name: name, control: control, defaultValue: value || defaultValue || "", rules: rules, render: ({ field }) => (_jsxs(StyledSelect, { IconComponent: (props) => _jsx(ArrowDown2, { size: 16, ...props }), ...field, labelId: "demo-simple-select-filled-label", id: "demo-simple-select-filled", value: field.value || "", variant: "filled", disableUnderline: true, disabled: disabled, displayEmpty: true, inputProps: { placeholder }, MenuProps: {
                        PaperProps: { sx: { maxHeight: 300 } },
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "center",
                        },
                    }, error: !!error, sx: {
                        height: height || "auto",
                        textAlign: "left",
                        background: backgroundColor,
                        "& .MuiSelect-select": {
                            borderRadius: "4px",
                        },
                        "& .MuiSelect-select.MuiSelect-select": {
                            color: !field.value ? "rgba(0, 0, 0, 0.6)" : "#00244D",
                        },
                    }, children: [placeholder && (_jsx(MenuItem, { value: "", disabled: true, sx: { display: "none" }, children: placeholder })), options.map((option) => (_jsx(MenuItem, { value: option.value, title: option.label, children: option.label }, option.value)))] })) }), error && _jsx(ErrorWithIcon, { error: error })] }));
};
